// 默认主题
import './styles/index.scss'
// 默认安装全部模块
import VXETable from './packages/vxe-table'

export * from './packages/vxe-table'
export default VXETable
